import { render, staticRenderFns } from "./ButtonMicrosoftLogin.vue?vue&type=template&id=5fa4d520&scoped=true"
import script from "./ButtonMicrosoftLogin.vue?vue&type=script&lang=js"
export * from "./ButtonMicrosoftLogin.vue?vue&type=script&lang=js"
import style0 from "./ButtonMicrosoftLogin.vue?vue&type=style&index=0&id=5fa4d520&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa4d520",
  null
  
)

export default component.exports